import { jsx as e } from "react/jsx-runtime";

import r from "@ui-components-3/ui/lib/components/FormControl";

import o from "@ui-components-3/ui/lib/components/DateTimePicker";

import { forwardRef as t, useRef as a, useCallback as n, useEffect as m, useImperativeHandle as l } from "react";

import { useFormContext as i, useController as s } from "react-hook-form";

import { format as u, isValid as c, parse as f } from "date-fns";

const p = t((({label: t, name: p, className: d, inputClassName: h, formControlProps: b, format: v = "MM-dd-yyyy", onBlur: y, ...C}, N) => {
    const T = a(null), {setValue: B, formState: {isSubmitted: D}} = i(), {field: g, fieldState: {error: k, isTouched: P}} = s({
        name: p
    }), {helper: S, helperVariant: V, ...w} = b || {}, x = !(!k?.message || !P && !D), {value: F} = g || {}, M = n((e => {
        B(p, e ? u(e, v) : null);
    }), [ v, p, B ]), j = n((() => {
        const e = T?.current?.value || "";
        let r = e;
        c(f(e, v, new Date)) || (r = null), B(p, r), g.onBlur();
    }), [ v, g, p, B ]), q = n((() => {
        const e = T?.current?.value;
        if (F || e) {
            if (F !== e) {
                // parse date to ensure input value is valid date
                const r = e ? f(e, v, new Date) : "";
                if (c(r)) {
                    const e = u(r, v);
                    e !== F && B(p, e);
                }
            }
            g.onBlur(), y?.();
        }
    }), [ v, g, p, y, B, F ]);
    return m((() => {
        const e = setTimeout((() => {
            q();
        }), 10);
        return () => {
            clearTimeout(e);
        };
    }), [ q ]), l(N, (() => T.current), []), e(r, {
        ...w,
        label: t,
        className: d,
        helper: x ? k?.message : S,
        helperVariant: x ? "error" : V,
        children: e(o, {
            autoComplete: "off",
            ...C,
            ...g,
            onChange: M,
            onBlur: j,
            variant: x ? "error" : C.variant,
            format: v,
            className: h,
            ref: T
        })
    });
}));

p.displayName = "FormDateTimePicker";

export { p as default };
//# sourceMappingURL=FormDateTimePicker.js.map
